export default "__VITE_ASSET__CUipybxR__"